import React, { useEffect } from 'react';
import {
    FormControl,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    OutlinedInputProps,
    FormHelperText,
} from '@mui/material';
import { IMaskInput } from 'react-imask';

interface PhoneInputProps extends OutlinedInputProps {
    onChange?: (event: { target: { name: string; value: string } }) => void;
    name?: string;
    label: string;
    message?: string;
}

const TextMaskCustom = React.forwardRef<HTMLElement, PhoneInputProps>(
    function TextMaskCustom(props: any, ref: any) {
        const { onChange, ...other } = props;

        return (
            <IMaskInput
                {...other}
                mask="0000 000 0000"
                definitions={{
                    '#': /[1-9]/,
                }}
                inputRef={ref}
                onAccept={(value: any) => {
                    onChange({
                        target: {
                            name:
                                props.name !== undefined
                                    ? props.name
                                    : Date.now(),
                            value: value,
                        },
                    });
                }}
            />
        );
    },
);

export function PhoneInput({
    label,
    onChange,
    error,
    value,
    message,
    ...other
}: PhoneInputProps): JSX.Element {
    const [textmask, setTextmask] = React.useState<string>('');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTextmask(event.target.value);
        if (onChange) onChange(event);
    };

    useEffect(() => {
        value && setTextmask(value + '');
    }, [value]);

    return (
        <FormControl
            sx={{ direction: 'ltr', textAlign: 'left' }}
            className="phone-from-control"
            fullWidth>
            <InputLabel
                error={error}
                htmlFor="formatted-text-mask-input"
                className="font-yekan-heavy">
                {label}
            </InputLabel>

            <OutlinedInput
                label={'شماره همراه'}
                error={error}
                {...other}
                value={textmask}
                type="tel"
                onChange={handleChange}
                className="font-sans"
                inputComponent={TextMaskCustom as any}
                autoFocus
                sx={{
                    '.MuiInputBase-input': {
                        direction: 'rtl',
                        textAlign: 'right',
                    },
                }}
                endAdornment={
                    <InputAdornment position="end">
                        <i className="fa-solid fa-mobile-notch" />
                    </InputAdornment>
                }
            />
            {error && (
                <FormHelperText sx={{ mt: 1.5, ml: 0 }} error={error}>
                    {message ?? ' لطفا شماره همراه معتبر وارد کنید'}
                </FormHelperText>
            )}
        </FormControl>
    );
}
